import BasePaymentController from 'app/src/controllers/payments/BasePaymentController';
import Localize from 'app/src/localize/Localize';
import GiftCardManager from 'app/src/payments/GiftCardManager';
import PaymentSelectGiftCardView from 'app/src/views/payments/PaymentSelectGiftCardView';

const _Events = {
  GIFT_CARD_SELECTED: 'gift:card:selected',
};

export default class PaymentSelectGiftCardViewController extends BasePaymentController {
  static get Event() {
    return _Events;
  }

  /**
   * @param saleManager {SaleManager} The sale manager associated with the sale
   * @param giftCardsInfo {array}  Customer info of gift cards
   * @param options {Object}  Controller options
   */
  constructor(saleManager, giftCardsInfo, options = {}) {
    super(saleManager);

    this._giftCardsInfo = giftCardsInfo;
    this._options = options;

    // initialize the controller's managed view
    this.view = new PaymentSelectGiftCardView({
      viewData: {
        giftCardsInfo,
      },
    });
  }

  /**
   * Event handler for when the user has selected a gift card from the results.
   *
   * @param cardNumber {string}   The gift card number
   */
  onSelectOneGiftCard(cardNumber) {
    GiftCardManager.fetchGiftCardDetails(cardNumber)
      .done((giftCardModel) => {
        if (giftCardModel.get('archived') === true) {
          // Show the disabled message
          let message = Localize.translate(
            `Gift card <var>${giftCardModel.get('code')}</var> has been disabled.` +
              " <a href='/register.php?form_name=view&name=credit_account.views.gift_card&id=" +
              `${giftCardModel.id}'>View gift card record</a>.`
          );
          flashNotifier('messages', message, 15);
        } else {
          // we always allow refunding a gift card no matter what the available balance
          if (
            this._saleManager.isRefundSale() ||
            giftCardModel.availableCreditBalance.isGreaterThan(0)
          ) {
            this.trigger(
              _Events.GIFT_CARD_SELECTED,
              giftCardModel,
              this._giftCardsInfo,
              this._options
            );
          } else {
            alertUser(Localize.translate('Gift card is empty.'));
          }
        }
      })
      .fail(() => {
        alertUser(Localize.translate('Gift card not found due to technical issues'));
      });
  }
}
